import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CTA.scss';

const CTA = () => {
    const navigate = useNavigate();

    const handleContactClick = () => {
        navigate('/contact');
    };

    return (
        <div className="cta-section">
            <h2>Ready to Transform Your Business?</h2>
            <p>Let's discuss how our LLM+RAG solutions can help you achieve your goals</p>
            <button className="cta-button" onClick={handleContactClick}>Contact Us</button>
        </div>
    );
};

export default CTA; 